export { default } from './category-tile';